'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Ejemplo = exports.Hand = exports.Card = exports.CardBack = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} ////////////
// card back


var isntOffCorner = function isntOffCorner(h, w, cr) {
  return function (cx, cy, r) {
    return cx >= cr && cx <= w - cr || cy >= cr && cy <= h - cr - 2 ? true : Math.pow(Math.pow(w / 2 - cr - Math.abs(w / 2 - cx), 2) + Math.pow(h / 2 - cr - 1 - Math.abs(h / 2 - 1 - cy), 2), 0.5) + r < cr;
  };
};

var r256 = function r256() {
  return Math.floor(Math.random() * 256);
};

var seedColors = ['rgb(' + r256() + ', ' + r256() + ', ' + r256() + ')', 'rgb(' + r256() + ', ' + r256() + ', ' + r256() + ')', 'rgb(' + r256() + ', ' + r256() + ', ' + r256() + ')'];
var deckBacks = {};

var generateCardBacks = function generateCardBacks(h, w, cr) {
  if (deckBacks[h + '/' + w + '/' + cr]) return;
  var cornerCheck = isntOffCorner(h, w, cr);
  var circles = [];
  Array(50).fill(1).forEach(function (o, oi, arr) {
    var r = Math.abs(Math.random() * 30 - 12);
    var op = Math.random() * 0.5 + 0.375;
    var cx = void 0,
        cy = void 0;
    var tries = 20;

    do {
      cx = r + 2 + Math.random() * (w - 2 * r - 4);
      cy = r + 2 + Math.random() * (h - 2 - 2 * r - 4);
    } while (--tries && (!cornerCheck(cx, cy, r + 3) || circles.filter(function (p) {
      return Math.pow(p.cx - cx, 2) + Math.pow(p.cy - cy, 2) < Math.pow(p.r + r + 4, 2);
    }).length));

    if (tries) circles.push({
      cx: cx,
      cy: cy,
      r: r,
      op: op
    });
  });
  deckBacks[h + '/' + w + '/' + cr] = {
    circles: circles
  };
};

generateCardBacks(160, 170, 20);

var CardBack = exports.CardBack = function CardBack(_ref) {
  var xOffset = _ref.xOffset,
      yOffset = _ref.yOffset,
      cardWidth = _ref.cardWidth,
      cardHeight = _ref.cardHeight;
  return !deckBacks[cardHeight + '/' + cardWidth + '/' + 20] ? generateCardBacks(cardHeight, cardWidth, 20) || CardBack({
    xOffset: xOffset,
    yOffset: yOffset,
    cardWidth: cardWidth,
    cardHeight: cardHeight
  }) : _react2.default.createElement('g', {
    transform: 'translate(' + xOffset + ', ' + yOffset + ')'
  }, _react2.default.createElement('rect', {
    width: cardWidth,
    height: cardHeight - 2,
    x: 0,
    y: 0,
    rx: 20,
    ry: 20,
    fill: seedColors[2],
    stroke: 'black'
  }), deckBacks[cardHeight + '/' + cardWidth + '/' + 20].circles.map(function (_ref2, ki) {
    var cx = _ref2.cx,
        cy = _ref2.cy,
        r = _ref2.r,
        op = _ref2.op;
    return _react2.default.createElement('circle', {
      key: ki,
      r: r,
      cx: cx,
      cy: cy,
      fill: seedColors[0],
      stroke: seedColors[1],
      opacity: op,
      strokeWidth: 2
    });
  }));
}; ///////
// Card


var ranks = ['joker', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', 'jack', 'queen', 'king'];
var suits = ['club', 'diamond', 'heart', 'spade'];
var displayRanks = ['*', 'A', '2', '3', '4', '5', '6', '7', '8', '9', '10', 'J', 'Q', 'K'];
var suitTokens = [_react2.default.createElement('g', null, _react2.default.createElement('path', {
  d: 'M3.35,4.66c0-1.81-1.51-3.28-3.38-3.28s-3.38,1.47-3.38,3.28c0,1.81,1.51,3.28,3.38,3.28S3.35,6.47,3.35,4.66z'
}), _react2.default.createElement('path', {
  d: 'M7.71-1.55c0-1.81-1.51-3.28-3.38-3.28S0.95-3.36,0.95-1.55c0,1.81,1.51,3.28,3.38,3.28S7.71,0.26,7.71-1.55z'
}), _react2.default.createElement('path', {
  d: 'M-0.95-1.57c0-0.66-0.2-1.28-0.55-1.8c-0.6-0.89-1.65-1.48-2.83-1.48c-1.87,0-3.38,1.47-3.38,3.28 c0,1.81,1.51,3.28,3.38,3.28S-0.95,0.24-0.95-1.57z'
}), _react2.default.createElement('path', {
  d: 'M3.94-7.94c-1.67,0-2.55,1.36-3.01,2.72C0.47-3.86,0.43-2.5,0.43-2.5h-0.86c0,0-0.16-5.43-3.5-5.44H3.94z'
}), _react2.default.createElement('path', {
  d: 'M-2.32,2.25c1.9-1.9,1.9-4.75,1.9-4.75l0.85-0.01c0,0,0,2.91,1.85,4.76'
}), _react2.default.createElement('path', {
  d: 'M-1.94-3.85c1.9,1.9,4.75,1.9,4.75,1.9v0.85c0,0-2.91,0-4.76,1.85'
}), _react2.default.createElement('path', {
  d: 'M1.87-3.86c-1.9,1.9-4.75,1.9-4.75,1.9v0.85c0,0,2.91,0,4.76,1.85'
})), _react2.default.createElement('g', null, _react2.default.createElement('path', {
  style: {
    fill: '#e6180a'
  },
  d: 'M0,0C-2.56,0-5.12,0-7.68,0C -6.8053,0.039-6.061,0.605-5.358,1.0728C-3.779,2.264-2.3,3.63 -1.132,5.228C-0.587,6.032 -0.0144,6.936 0,7.94M-7.68,0C-6.57,-0.035 -5.622,-0.7413 -4.776,-1.393C-3.281,-2.648 -1.987,-4.141 -0.895,-5.757C-0.494,-6.426 -0.022,-7.135 0,-7.94C0,-5.293 0,-2.647 0,0M0,-7.94C0.038,-6.758 0.758,-5.734 1.438,-4.82C2.65,-3.310 4.086,-1.974 5.666,-0.857C6.28,-0.474 6.932,-0.0185 7.68,0C5.12,0 2.56,0 0,0M 7.68,0C6.57,0.035 5.622,0.741 4.776,1.392C 3.281,2.648 1.987,4.141 0.895,5.757C0.494,6.426 0.0225,7.135 0,7.94C0,5.293 0,2.647 0,0'
})), _react2.default.createElement('g', null, _react2.default.createElement('path', {
  style: {
    fill: '#e6180a'
  },
  d: 'M-7.67,3.93c0.01-4.71,5.91-8.14,7.64-11.87c1.75,3.72,7.66,7.12,7.7,11.83c0.01,2.22-1.71,4.03-3.82,4.03C1.73,7.92,0,6.13,0,3.91c0,2.23-1.71,4.03-3.82,4.03C-5.94,7.95-7.66,6.15-7.67,3.93z'
})), _react2.default.createElement('g', null, _react2.default.createElement('path', {
  d: 'M3.92-7.93c-1.67,0-2.55,1.78-3.01,3.56c-0.46,1.78-0.5,3.56-0.5,3.56L-0.44-0.8c0,0-0.16-7.13-3.5-7.13H3.92z'
}), _react2.default.createElement('path', {
  d: 'M6.75-0.8C6.74,2.67,1.53,5.19,0,7.93C-1.53,5.18-6.74,2.66-6.75-0.8c0-1.64,1.51-2.97,3.38-2.97C-1.51-3.77,0-2.44,0-0.8c0-1.64,1.51-2.97,3.38-2.97S6.75-2.44,6.75-0.8z'
}))];
var suitFills = ['#ddddee', 'white', '#ffe6cc', 'white'];

var Card = exports.Card = function Card(_ref3) {
  var rank = _ref3.rank,
      suit = _ref3.suit,
      fill = _ref3.fill,
      cardWidth = _ref3.cardWidth,
      cardHeight = _ref3.cardHeight,
      xOffset = _ref3.xOffset,
      yOffset = _ref3.yOffset,
      onClick = _ref3.onClick;
  return _react2.default.createElement('g', {
    transform: 'translate(' + xOffset + ', ' + yOffset + ')',
    onClick: onClick
  }, _react2.default.createElement('rect', {
    width: cardWidth,
    height: cardHeight - 2,
    x: 0,
    y: 0,
    rx: 20,
    ry: 20,
    fill: suitFills[suit],
    stroke: 'black'
  }), _react2.default.createElement('text', {
    fontWeight: 'bold',
    transform: 'translate(7, 40) ' + (rank !== 10 ? '' : 'scale(0.5, 1)'),
    fontFamily: 'monospace',
    fill: (suit + 1) % 4 < 2 ? 'black' : '#e6180a',
    style: {
      cursor: 'default'
    },
    fontSize: 43
  }, displayRanks[rank]), _react2.default.createElement('g', {
    transform: 'translate(' + 21 + ',' + 60 + ') rotate(180)'
  }, suitTokens[suit]));
}; ///////
// Hand


var Hand = exports.Hand = function Hand(_ref4) {
  var _ref4$cards = _ref4.cards,
      cards = _ref4$cards === undefined ? [] : _ref4$cards,
      _onClick = _ref4.onClick,
      hidden = _ref4.hidden,
      _ref4$style = _ref4.style,
      style = _ref4$style === undefined ? {} : _ref4$style,
      _ref4$cardWidth = _ref4.cardWidth,
      cardWidth = _ref4$cardWidth === undefined ? 170 : _ref4$cardWidth,
      _ref4$cardHeight = _ref4.cardHeight,
      cardHeight = _ref4$cardHeight === undefined ? 160 : _ref4$cardHeight,
      _ref4$cardOffset = _ref4.cardOffset,
      cardOffset = _ref4$cardOffset === undefined ? 100 : _ref4$cardOffset,
      _ref4$selectionHeight = _ref4.selectionHeight,
      selectionHeight = _ref4$selectionHeight === undefined ? 20 : _ref4$selectionHeight;
  return _react2.default.createElement('svg', {
    viewBox: '-2 -2 ' + (cardOffset * (cards.length || 1) + 4 + (cardWidth - cardOffset)) + ' ' + (2 + cardHeight + selectionHeight),
    style: style
  }, cards.map(function (card, i) {
    return !card.rank ? null : hidden || card.hidden ? _react2.default.createElement(CardBack, {
      key: i,
      cardWidth: cardWidth,
      cardHeight: cardHeight,
      xOffset: i * cardOffset,
      yOffset: selectionHeight
    }) : _react2.default.createElement(Card, {
      key: card.rank + '' + card.suit + '' + i,
      cardWidth: cardWidth,
      cardHeight: cardHeight,
      onClick: function onClick() {
        return _onClick(i);
      },
      rank: card.rank,
      suit: card.suit,
      xOffset: i * cardOffset,
      yOffset: selectionHeight * !card.selected
    });
  }));
}; //////////
// ejemplo


var defHandStyle = {
  maxHeight: '34vh',
  minHeight: '34vh',
  maxWidth: '100vw',
  padding: 0
};

var Ejemplo = exports.Ejemplo = function Ejemplo() {
  return _react2.default.createElement('div', null, _react2.default.createElement(Hand, {
    cards: [{
      rank: 1
    }, {
      rank: 2
    }, {
      rank: 3
    }],
    hidden: true,
    style: defHandStyle
  }), _react2.default.createElement(Hand, {
    cards: [{
      rank: 1,
      suit: 0
    }, {
      rank: 10,
      suit: 1
    }, {
      rank: 13,
      suit: 2
    }, {
      rank: 3,
      suit: 3
    }],
    style: defHandStyle
  }));
};